import React, { Component } from "react";
import { ROUTES_CONFIG } from "src/constants/routesConfig";
import { WrapperProps } from "src/types/wrapper";
import { StatusModals } from "src/components";

class ErrorBoundary extends Component<WrapperProps, { hasError: boolean }> {
  constructor(props: WrapperProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught in ErrorBoundary: ", error, errorInfo);
  }

  handleResetError = () => {
    this.setState({ hasError: false });
    window.location.href = ROUTES_CONFIG.home.path;
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <StatusModals.Error
          children={
            <button
              className="text-black border border-black bg-white text-sm font-normal py-1.5 px-0 transition-all duration-300 rounded-[32px] w-[200px] min-w-[50px] hover:cursor-pointer disabled:cursor-auto disabled:text-gray-300 text-center"
              onClick={this.handleResetError}
            >
              Restart
            </button>
          }
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
